import { render, staticRenderFns } from "./PasswordReset.vue?vue&type=template&id=f49b7bd6&scoped=true&"
import script from "./PasswordReset.vue?vue&type=script&lang=js&"
export * from "./PasswordReset.vue?vue&type=script&lang=js&"
import style0 from "./PasswordReset.vue?vue&type=style&index=0&id=f49b7bd6&scoped=true&lang=css&"
import style1 from "./PasswordReset.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f49b7bd6",
  null
  
)

export default component.exports